import { ReactNode } from 'react';
import { DEVELOPER_ROLE, OWNER_ROLE, Role } from 'store/api/types';

export const NONE_ROLE = 'NONE';

export type RolesContextType = {
  roles: Role[];
  getRoleInAccount: (account: string) => typeof OWNER_ROLE | typeof DEVELOPER_ROLE | typeof NONE_ROLE;
};

export type RolesContextProviderProps = {
  roles: Role[];
  children: ReactNode;
};
